import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export function VersionBadge({ className = "" }) {
    const [v, setV] = useState(null);
    useEffect(() => {
        api.get("/releases").then((r) => setV(r.data.current_version)).catch(() => {});
    }, []);
    if (!v) return null;
    return (
        <Link
            to="/releases"
            data-testid="version-badge"
            className={`font-mono text-muted-foreground hover:text-brand-teal transition-colors ${className}`}
        >
            v{v}
        </Link>
    );
}
